import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LangService } from 'src/app/core/lang.service';
import { applyThousandsSpaces } from 'src/app/core/styleprofile.service';

@Component({
  selector: 'radio-lang-select',
  templateUrl: './radio-lang-select.component.html',
  styleUrls: ['./radio-lang-select.component.scss']
})
export class RadioLangSelectComponent implements OnInit {
  
  @Input() languages?: [string, string][] = undefined; // [code, caption][]
  
  @Output() getSelectedLang = new EventEmitter<string>();
  
  public selectedLanguage: string = 'en';
  
  constructor(
    public langService: LangService
  ) { }

  ngOnInit(): void {
    if (!this.languages || !this.languages.length){ 
      this.handleLangChange(this.langService.c());
      this.languages = Object.entries(this.langService.getKnownLanguages())
        .sort(([keyA], [keyB]) => {
        if (keyA === this.selectedLanguage) return -1; 
        if (keyB === this.selectedLanguage) return 1;
        return 0;
      });
    }
  }
  
  handleLangChange(lang: string) {
    this.selectedLanguage = lang;
    this.getSelectedLang.emit(lang);
  }
}
